/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { Panel, FlexGrid, Divider, Header, Button, Loader } from '@gasbuddy/react-components';
import styles from './styles.css';
import shared from '../../styles/shared.css';
import ErrorBoundary from '../error-boundary/error-boundary';

const { gTagEvent } = require('../../../lib/global-site-tag').default;

class Card extends React.Component {
  static defaultProps = {
    className: '',
    showCollapseButton: false,
    showEditButton: false,
    showShareButton: false,
    showInfoButton: false,
    onEditClick: undefined, // will remove after BP-3890
    largeTitle: false,
    isLoading: false,
    minHeight: 0,
    editModal: null,
    hasError: false,
  };

  static propTypes = {
    className: PropTypes.string,
    showCollapseButton: PropTypes.bool,
    showEditButton: PropTypes.bool,
    showShareButton: PropTypes.bool,
    showInfoButton: PropTypes.bool,
    title: PropTypes.node.isRequired,
    onEditClick: PropTypes.func, // will remove after BP-3890
    children: PropTypes.node.isRequired,
    largeTitle: PropTypes.bool,
    isLoading: PropTypes.bool,
    minHeight: PropTypes.number,
    editModal: PropTypes.node,
    hasError: PropTypes.bool,
  }

  state = {
    isCollapsed: false,
  }

  handleOnEditClick = () => { // will remove after BP-3890
    const { onEditClick } = this.props;
    if (onEditClick) {
      onEditClick();
    }
  }

  handleOnCollapse = () => {
    gTagEvent(`${this.props.title.replace(/-.+$/, '')} Card`, `${this.state.isCollapsed ? 'Expanded' : 'Collapsed'} The Card`);
    this.setState(prevState => ({
      isCollapsed: !prevState.isCollapsed,
    }));
  }

  handleOnShare = () => {
  }

  render() {
    const {
      className,
      showCollapseButton,
      minHeight,
      showEditButton,
      showShareButton,
      showInfoButton,
      title,
      children,
      largeTitle,
      isLoading,
      editModal,
      hasError,
    } = this.props;
    const { isCollapsed } = this.state;

    const editButton = editModal
      ? (
        <editModal.type {...editModal.props} buttonClassName={styles.buttonIcon} />
      )
      : (
        <Button // will remove after BP-3890
          type="button"
          className={styles.buttonIcon}
          link
          rounded={false}
          onClick={this.handleOnEditClick}
        >
          <FontAwesomeIcon icon={faPen} />
        </Button>
      );

    return (
      <Panel raised className={`${styles.card} ${className}`} style={{ minHeight: isCollapsed ? 0 : minHeight }}>
        <ErrorBoundary>
          <FlexGrid container>
            <FlexGrid.Column className={styles.title}>
              <FlexGrid>
                <div>
                  <Header as={largeTitle ? 'h2' : 'h3'} size="sm" className={shared.pullLeft}>{title}</Header>
                </div>
              </FlexGrid>
              <div>
                {showEditButton && !isLoading && editButton}
                {showInfoButton && (
                <Button
                  type="button"
                  className={styles.buttonIcon}
                  link
                  rounded={false}
                  onClick={this.handleOnInfo}
                >
                  <FontAwesomeIcon icon={faInfoCircle} />
                </Button>
                )}
                {showShareButton && (
                <Button
                  type="button"
                  className={styles.buttonIcon}
                  link
                  rounded={false}
                  onClick={this.handleOnShare}
                >
                  <FontAwesomeIcon icon={faShareAlt} />
                </Button>
                )}
                {showCollapseButton && (
                <Button
                  type="button"
                  className={styles.buttonIcon}
                  link
                  rounded={false}
                  onClick={this.handleOnCollapse}
                >
                  <FontAwesomeIcon icon={isCollapsed ? faChevronDown : faChevronUp} />
                </Button>
                )}
              </div>
            </FlexGrid.Column>
          </FlexGrid>
          {!isCollapsed && (
          <FlexGrid>
            <FlexGrid.Column>
              <Divider />
            </FlexGrid.Column>
            {isLoading && !hasError ? <Loader className={styles.center} /> : (
              <FlexGrid.Column className={styles.content}>
                <ErrorBoundary hasError={hasError}>
                  {children}
                </ErrorBoundary>
              </FlexGrid.Column>
            )}
          </FlexGrid>
          )}
        </ErrorBoundary>
      </Panel>
    );
  }
}

export default Card;
